import { ReactNode } from 'react'
import { Scrollbars } from 'react-custom-scrollbars-2'

/**
 *  Группа Badges в три строки по умолчанию, со скролингом, если превышает
 */

const rowHeight = 36
const renderNoScroll = () => <span />

export type PlainBadgesGroupProps = {
  className?: string
  maxRows?: number
  children: ReactNode
}

/**
 * Компонент для группировки бейджей с ограниченным количеством отображаемых строк.
 *
 * Оборачивает содержимое в элемент с вертикальной прокруткой,
 * ограничивая максимальное количество отображаемых строк.
 * Горизонтальная прокрутка скрыта.
 *
 * @param {object} props
 * @param {string} props.className - Класс для добавления к контейнеру.
 * @param {number} props.maxRows - Максимальное количество отображаемых строк (по умолчанию 3).
 * @param {React.ReactNode} props.children - Содержимое компонента (бейджи).
 * @returns {JSX.Element} JSX элемент, представляющий компонент.
 */
const PlainBadgesGroup = ({ className, maxRows = 3, children }: PlainBadgesGroupProps) => {
  return (
    <Scrollbars
      className={className}
      autoHeight
      autoHeightMin={0}
      autoHeightMax={maxRows * rowHeight}
      renderTrackHorizontal={renderNoScroll}
    >
      {children}
    </Scrollbars>
  )
}

export default PlainBadgesGroup
